import { useIntl } from '@capsicum/common';

export const useNCWRecipientCreate = () => {
	const { $t } = useIntl();

	return {
		intlText: {
			alert: $t('wallet.withdraw.recipient.createRecipient.alert'),
			cancel: $t('wallet.withdraw.recipient.createRecipient.cancel'),
			createButtonLabel: $t('wallet.withdraw.recipient.createRecipient.createButtonLabel'),
			notificationSuccess: $t('wallet.withdraw.recipient.createRecipient.notificationSuccess'),
			title: $t('wallet.withdraw.recipient.createRecipient.pageTitle')
		}
	};
};
